// key can be of type x or x[ 2 ] or x [ "y" ]. Should NOT have any '.' in the key
const getValue = (k, json) => {
  let key = k;
  if (!key || key.indexOf('.') !== -1) {
    throw new Error(`Invalid key ${key}`);
  }

  if (!json) {
    return undefined;
  }

  const reg = /([^[]*)\[([^\]]*)\s*\]/;
  const match = reg.exec(key);
  let index;
  let value;

  if (match) {
    key = match[1];
    index = match[2].trim();
  }

  value = json[key];

  if (value && index !== undefined) {
    value = value[index];
  }

  return value;
};

module.exports = (key, json) => {
  if (!key || !json) {
    return undefined;
  }

  const parts = key.split('.');
  let part;
  let i = 0;
  const l = parts.length;
  let context = json;

  for (; i < l; i++) {
    part = parts[i];
    context = getValue(part, context);
  }

  return context;
};
